import React, { useState, useMemo } from "react";
import { AdminFunction } from "./types";
import "./AdminEvent.css";

interface FunctionListProps {
    functions: AdminFunction[];
    onEdit: (func: AdminFunction) => void;
    onDelete: (functionID: number) => void;
}

const FunctionList: React.FC<FunctionListProps> = ({ functions, onEdit, onDelete }) => {
    const [search, setSearch] = useState("");

    const filteredFunctions = useMemo(() => {
        return functions.filter((f) => {
            const searchLower = search.toLowerCase();

            return (
                f.functionName.toLowerCase().includes(searchLower) ||
                f.description?.toLowerCase().includes(searchLower) ||
                f.categoryName?.toLowerCase().includes(searchLower) ||
                f.assignedZones?.some((z) =>
                    z.zoneName.toLowerCase().includes(searchLower) ||
                    z.number.toString().includes(searchLower)
                )
            );
        });
    }, [functions, search]);

    return (
        <div className="function-table-container">
            <div className="function-search">
                <input
                    type="text"
                    placeholder="Søg funktion, kategori, beskrivelse eller zone..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />
            </div>

            <table className="event-table event-table-modern">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Funktion Navn</th>
                        <th>Kategori</th>
                        <th>Beskrivelse</th>
                        <th>Kortdesign</th>
                        <th>Zones</th>
                        <th>Handlinger</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredFunctions.map((f) => (
                        <tr key={f.functionID}>
                            <td>{f.functionID}</td>
                            <td>{f.functionName}</td>
                            <td>{f.categoryName || "-"}</td>
                            <td>{f.description || "-"}</td>
                            <td>{f.useDesign2 ? "Design 2" : "Design 1"}</td>
                            <td>
                                {f.assignedZones?.length ? (
                                    <div className="zone-chip-container">
                                        {f.assignedZones.map((z) => (
                                            <div key={z.zoneID} className="zone-chip">
                                                <strong>{z.number}</strong> -{" "}
                                                <span className="zone-chip-name">{z.zoneName}</span>
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <span className="no-zones">Ingen zones</span>
                                )}
                            </td>
                            <td>
                                <div className="table-buttons">
                                    <button className="edit-btn" onClick={() => onEdit(f)}>
                                        Rediger
                                    </button>
                                    <button className="delete-btn" onClick={() => onDelete(f.functionID!)}>
                                        Slet
                                    </button>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default FunctionList;